import React, { useState } from 'react';
import { useInternationalization } from '@progress/kendo-react-intl';
import { useNavigate } from 'react-router-dom';

import { MobileDataItemProps } from './mobileDataItemProps';

import Icon from '../../../../../../ui/icon/icon';

const MobileDataItem: React.FC<MobileDataItemProps> = ({
                                                         dataItem,
                                                         key,
                                                         isLink,
                                                         columns,
                                                         link,
                                                         staticProperties,
                                                         handleOpenCashflow,
                                                         singlePeriod,
                                                         investorObjectId,
                                                         selectedCurrency,
                                                         boardId,
                                                       }) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  const intl = useInternationalization();
  const navigate = useNavigate();

  const formatProperty = (dataItem, column, property) => {
    let field = singlePeriod ? `ID${column.columnId}_${column.type}_${column.templatePropertyId}_rowAmount` :
      `ID${column.columnId}_${column.type}_${column.templatePropertyId}_${column.nodeId}_rowAmount`;
    let propertyItem = dataItem[field];
    if (propertyItem && property?.type === 'website') {
      return <a className='link' target='_blank'
                href={(propertyItem.includes('https://') || propertyItem.includes('http://')) ? propertyItem : `https://${propertyItem}`}>{propertyItem}</a>;
    } else {
      if (property?.dataType === 'date') {
        propertyItem = intl.toString(new Date(propertyItem), 'd');
      }

      if (property?.dataType === 'number' || property?.dataType === 'percent') {
        let format = property?.dataType === 'percent' ? 'p' : 'n';
        propertyItem = intl.toString(propertyItem, `${format}${property?.scale}`);
      }

      if (propertyItem !== null && !isNaN(new Date(propertyItem).getTime())) {
        propertyItem = intl.formatDate(new Date(propertyItem), 'd');
      }

      return <span>{propertyItem}</span>;
    }
  };

  const formatNumber = (dataItem, column) => {
    let field = singlePeriod ? `ID${column.columnId}_${column.type}_${column.measureId}` : `ID${column.columnId}_${column.type}_${column.measureId}_${column.nodeId}`;
    let item = dataItem[field];

    if (typeof item === 'object') {
      return <span className={`${column.viewCashflows ? 'link' : ''}`}
                   onClick={() => column.viewCashflows && handleOpenCashflow && handleOpenCashflow(dataItem, field, column.name, boardId, investorObjectId, false, singlePeriod, selectedCurrency)}>
        {item.rowAmount === null ? '' : intl.toString(item.rowAmount, (item.isPercent ? 'p' : 'n') + column.scale || item.scale)}
      </span>;
    }
    return <span className={`${column.viewCashflows ? 'link' : ''}`}>
      {item}
    </span>;
  };

  return (
    <li className={`data-item`} key={key}>
      <span className={`title ${isLink ? 'link pointer' : ''}`} onClick={() => {
        if (isLink && link)
          navigate(link);
      }}>{singlePeriod ? dataItem.name : dataItem.periodName}</span>
      <Icon name={`fas ${!expanded ? 'fa-chevron-down' : 'fa-chevron-up'}`} className='pointer'
            onClick={() => setExpanded(!expanded)} />
      {expanded && <ul className='expanded-container'>
        {columns.filter((c) => !c.hideOnMobile).map((column, key) => {
          if (column.type === 'property') {
            return <li key={key} className='column'>
              <span className='column-name'>{column.name}</span>
              <div
                className='column-value'>{formatProperty(dataItem, column, staticProperties[column.templatePropertyId])}</div>
            </li>;
          } else {
            return <li key={key} className='column'>
              <span className='column-name'>{column.name}</span>
              <span
                className='column-value'>{formatNumber(dataItem, column)}</span>
            </li>;
          }
        })}
      </ul>}
    </li>
  );
};

export default MobileDataItem;